import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import { apiKey } from "../config/config";
import Table from "../components/Table";
import Receipt from "../components/Receipt";

function TransactionReports({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin,
  ).branch_id;

  const [reports, setReports] = useState([]);
  const [filter, setFilter] = useState([]);
  const [investorList, setInvestorList] = useState([]);
  const [investor, setInvestor] = useState();
  const [branch, setBranch] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  function convertDateFormat(inputDate) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    const formattedDate = dateObject.toLocaleDateString("en-GB", options);
    return formattedDate;
  }

  const columns = [
    {
      header: lang.Investor || "Investor",
      accessorKey: "FullName",
      footer: info => lang["Total"] || "Total"
    },
    {
      header: lang.Amount || "Amount",
      accessorKey: "amount",
      footer: (info) => {
        const total = info.table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => {
            const { amount } = row.original;
            return sum + Number(amount || 0);
          }, 0);
        return `${total.toFixed(2)}`;
      },
    },
    {
      header: lang.Type || "Type",
      accessorKey: "type",
      cell: (type) => {
        return type.getValue() === "deposit"
          ? lang["Deposit"] || "Deposit"
          : lang["Withdrawal"] || "Withdrawal";
      },
    },
    {
      header: lang.date || "Date",
      accessorKey: "date",
      cell: (row) => convertDateFormat(row.row.original.date),
    },
    {
      header: lang["Added By"] || "Added By",
      accessorKey: "created_by",
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <Receipt
          lang={lang}
          receiptData={row.row.original}
          branchData={branch}
          idx={row.row.index}
        />
      ),
    },
  ];

  useEffect(() => {
    if (filter !== "from_to") {
      setFrom();
      setTo();
    }
    if (branchId) {
      axios
        .get(apiKey + "/transaction-reports", {
          params: {
            branch_id: branchId,
            filter,
            investor_id: investor,
            from,
            to,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setReports(res.data.result);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, filter, investor, from, to, token]);
  useEffect(() => {
    axios
      .get(apiKey + "/investor", {
        params: {
          branch_id: branchId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setInvestorList(res.data.result);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [branchId, token]);
  useEffect(() => {
    if (branchId) {
      axios
        .get(`${apiKey}/get-dealer/${branchId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setBranch(res.data.result[0]);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [branchId, token]);

  return (
    <main className="main" id="main">
      <div className="pagetitle">
        <h1>{lang.Reports || "Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
            <li className="breadcrumb-item active">
              {lang.transaction_report || "Transaction Reports"}
            </li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="mt-3 mb-3">
                  <div className="rr">
                    {lang.transaction_report || "Transaction Reports"}
                  </div>
                  <div className="row justify-content-end gap-2">
                    {filter === "from_to" && (
                      <>
                        <div className="custom-datepicker">
                          <DatePicker
                            placeholder={lang["from_text"] || "From"}
                            style={{
                              left: "35%",
                              top: "5px",
                              height: "auto",
                            }}
                            containerStyle={{
                              height: "auto",
                            }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setFrom(dateObject);
                            }}
                          />
                        </div>
                        <div className="custom-datepicker">
                          <DatePicker
                            className=" btn-exportform-control w-100"
                            placeholder={lang["to_text"] || "To"}
                            style={{
                              left: "45%",
                              top: "5px",
                              height: "auto",
                            }}
                            containerStyle={{
                              height: "auto",
                            }}
                            onChange={(e) => {
                              const dateObject = new Date(e);
                              setTo(dateObject);
                            }}
                          />
                        </div>
                      </>
                    )}
                    <select
                      onChange={(e) => setFilter(e.target.value)}
                      className="btn-export me-0 mb-4 mb-md-0 col-3"
                      name="time"
                      id="time"
                    >
                      <option value="">{lang.All_Time || "All Time"}</option>
                      <option value="today">{lang.Today || "Today"}</option>
                      <option value="this_week">
                        {lang.This_Week || "This Week"}
                      </option>
                      <option value="this_month">
                        {lang.This_Month || "This Month"}
                      </option>
                      <option value="this_year">
                        {lang.This_Year || "This Year"}
                      </option>
                      <option value="from_to">
                        {lang["From To"] || "From To"}
                      </option>
                    </select>
                    <select
                      onChange={(e) => setInvestor(e.target.value)}
                      className="btn-export col-3"
                      name="inv"
                      id="inv"
                    >
                      <option value="">
                        {lang.all_investors || "All Investors"}
                      </option>
                      {investorList.map((investor, index) => (
                        <option key={index} value={investor.id}>
                          {investor.FullName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div classNames="d-flex mt-3 mb-3">
                  <Table
                    lang={lang}
                    data={reports}
                    columns={columns}
                    footer={true}
                    exportOption={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TransactionReports;
